import { ReactNode } from 'react';
import clsx from 'clsx';
import type { IListElement } from '../../types/IListElement';

export interface IUserMenuItemOptions {
    /** Ключ пункта: `data-testid` подписи — `settings-item-<value>`, пункта — `rf-list-element-<value>` */
    value: string;
    label: ReactNode;
    /** Иконка 24px */
    icon: ReactNode;
    onSelect: () => void;
    /** Опасное действие (выход) — цветом ошибки */
    danger?: boolean;
    /** Свой `data-testid` подписи; `false` — без него */
    testId?: string | false;
}

/** Пункт меню профиля для `UserMenuList` и разделов `UserMenuDialog`. */
export const userMenuItem = ({ value, label, icon, onSelect, danger, testId }: IUserMenuItemOptions): IListElement => ({
    value,
    label: (
        <div
            className={clsx('settings-item', danger && 'settings-item--logout')}
            data-testid={testId === false ? undefined : (testId ?? `settings-item-${value}`)}
        >
            {icon}
            <span>{label}</span>
        </div>
    ),
    handler: onSelect,
});
